"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function showLogPosition() {
    // 寻找所有自定义埋点元素
    document.querySelectorAll('[data-yxlogtag]').forEach(item => {
        if (!item)
            return;
        appendLogTag(item);
    });
    addStyle();
}
// 为每个埋点元素同级添加可以展示相关埋点信息的元素
function appendLogTag(item) {
    // 设置父元素为相对定位
    item.style.position = 'relative';
    const el = document.createElement('div');
    el.classList.add('yx-log-cls');
    const childInfo = document.createElement('span');
    childInfo.innerText = logInfo(item.attributes);
    childInfo.classList.add('yx-log-tag');
    el.appendChild(childInfo);
    item.appendChild(el);
}
function addStyle() {
    if (document.getElementById('yxLogCls'))
        return;
    const style = document.createElement('style');
    style.id = 'yxLogCls';
    style.innerText = `
    .yx-log-cls {
      position: absolute;
      left: 0;
      top: 50%;
      min-width: 20px;
      min-height: 20px;
      background: blue;
      border-radius: 10px;
      transform: translate(0, -50%);
      z-index: 1;
    } 

    .yx-log-tag {
      color: white;
      display: none;
      padding: 4px;
    }

    .yx-log-cls:hover .yx-log-tag {
      display: block;
    }
  `.replace(/\s/g, ' ');
    document.head.appendChild(style);
}
// 先不考虑data-yxlogtag存在额外参数的情况
function logInfo(attributes) {
    let logtag = '';
    const logtagAttr = attributes.getNamedItem('data-yxlogtag');
    if (logtagAttr != null)
        logtag = logtagAttr.value;
    if (!logtag)
        return '';
    const json = {};
    for (let i = 0, len = attributes.length; i < len; i++) {
        const attr = attributes.item(i);
        if (!attr)
            continue;
        if (attr.name.startsWith('data-yxlogtag:')) {
            json[attr.name.substring('data-yxlogtag:'.length)] = attr.value;
        }
        else if (attr.name.startsWith('data-yxlogtag__')) {
            json[attr.name.substring('data-yxlogtag__'.length)] = attr.value;
        }
    }
    const jsonString = Object.keys(json).length === 0 ? '' : JSON.stringify(json);
    return logtag + '|' + jsonString;
}
exports.default = showLogPosition;
